// Stat card used on the Dashboard for plan-credit summaries. It is a 3D flip-card:
// a front face (icon + title + count) and an optional back face (description +
// action link) that swaps in via a Y-axis rotation. Cards without a back face
// render the front on its own.

const itemFrameClasses = 'rounded-md text-left relative w-full h-50';

// Stone, the nested surface for cards sitting on the dashboard's Ivory panel.
const itemBaseClasses =
    `${itemFrameClasses} bg-surface-alt ` +
    '[transform-style:preserve-3d] transition-transform duration-[600ms]';

const itemFlippedClasses = '[transform:rotateY(180deg)]';

const faceBaseClasses =
    'absolute top-0 left-0 w-full h-full ' +
    '[backface-visibility:hidden] pt-6 px-6 pb-2.5';

const frontFaceClasses = `${faceBaseClasses} cursor-pointer`;

const staticFaceClasses = `${faceBaseClasses} cursor-default`;

// Flat Ocean with Ivory type, the palette's approved pairing; the darker
// primary-hover step belongs to hover states, not to a resting surface.
const backFaceClasses =
    `${faceBaseClasses} bg-primary text-surface ` +
    'flex flex-col items-baseline rounded-md text-sm ' +
    '[transform:rotateY(180deg)] cursor-pointer';

// The wrapper owns the icon colour so each face can recolour a currentColor glyph
// without the call site having to know which face it lands on.
const iconBaseClasses = 'flex absolute bottom-2.5 right-2.5 text-primary';

const oceanIconClasses = `${iconBaseClasses} text-surface!`;

const titleBaseClasses = 'block text-2xl font-bold text-subtle mb-1.5';

const oceanTitleClasses = 'block text-2xl font-bold text-surface! mb-1!';

const countClasses =
    'bg-transparent block text-subtle p-0 text-sm w-auto mb-3 ' +
    '[&>span]:text-stat-count [&>span]:font-bold [&>span]:text-content';

const descriptionClasses = 'mb-1';

const linkClasses = 'text-surface underline';

const StatsCard = ({ icon, title, count, description, linkText, flippable, isFlipped, onToggle }) => {
    if (!flippable) {
        return (
            <div className={itemBaseClasses}>
                <div className={staticFaceClasses}>
                    {icon && <span className={iconBaseClasses}>{icon}</span>}
                    <p className={titleBaseClasses}>{title}</p>
                    <span className={countClasses}>{count}</span>
                </div>
            </div>
        );
    }

    return (
        <div className={`${itemBaseClasses} ${isFlipped ? itemFlippedClasses : ''}`}>
            <div className={frontFaceClasses} onClick={onToggle}>
                {icon && <span className={iconBaseClasses}>{icon}</span>}
                <p className={titleBaseClasses}>{title}</p>
                <span className={countClasses}>{count}</span>
            </div>
            <div className={backFaceClasses} onClick={onToggle}>
                {icon && <span className={oceanIconClasses}>{icon}</span>}
                <p className={oceanTitleClasses}>{title}</p>
                <p className={descriptionClasses}>{description}</p>
                {linkText && <a className={linkClasses}>{linkText}</a>}
            </div>
        </div>
    );
};

export default StatsCard;
